// @ts-nocheck
import client from "../../utils/axios";
import { useQuery, queryOptions, useSuspenseQuery } from "@tanstack/react-query";
import type { CustomFieldFindManyQueryResponse, CustomFieldFindManyQueryParams, CustomFieldFindMany401 } from "../models/CustomFieldFindMany";
import type { QueryObserverOptions, UseQueryResult, QueryKey, UseSuspenseQueryOptions, UseSuspenseQueryResult } from "@tanstack/react-query";

 type CustomFieldFindManyClient = typeof client<CustomFieldFindManyQueryResponse, CustomFieldFindMany401, never>;
type CustomFieldFindMany = {
    data: CustomFieldFindManyQueryResponse;
    error: CustomFieldFindMany401;
    request: never;
    pathParams: never;
    queryParams: CustomFieldFindManyQueryParams;
    headerParams: never;
    response: CustomFieldFindManyQueryResponse;
    client: {
        parameters: Partial<Parameters<CustomFieldFindManyClient>[0]>;
        return: Awaited<ReturnType<CustomFieldFindManyClient>>;
    };
};
export const customFieldFindManyQueryKey = (params?: CustomFieldFindMany["queryParams"]) => ["api", "v5", "custom_fields", ...(params ? [params] : [])] as const;
export type CustomFieldFindManyQueryKey = ReturnType<typeof customFieldFindManyQueryKey>;
export function customFieldFindManyQueryOptions(params?: CustomFieldFindMany["queryParams"], options: CustomFieldFindMany["client"]["parameters"] = {}) {
    const queryKey = customFieldFindManyQueryKey(params);
    return queryOptions({
        queryKey,
        queryFn: async () => {
            const res = await client<CustomFieldFindMany["data"], CustomFieldFindMany["error"]>({
                method: "get",
                url: `/api/v5/custom_fields`,
                params,
                ...options
            });
            return res.data;
        },
    });
}
/**
 * @summary Find many CustomFieldEntity with query
 * @link /api/v5/custom_fields
 */
export function useCustomFieldFindMany<TData = CustomFieldFindMany["response"], TQueryData = CustomFieldFindMany["response"], TQueryKey extends QueryKey = CustomFieldFindManyQueryKey>(params?: CustomFieldFindMany["queryParams"], options: {
    query?: Partial<QueryObserverOptions<CustomFieldFindMany["response"], CustomFieldFindMany["error"], TData, TQueryData, TQueryKey>>;
    client?: CustomFieldFindMany["client"]["parameters"];
} = {}): UseQueryResult<TData, CustomFieldFindMany["error"]> & {
    queryKey: TQueryKey;
} {
    const { query: queryOptions, client: clientOptions = {} } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? customFieldFindManyQueryKey(params);
    const query = useQuery({
        ...customFieldFindManyQueryOptions(params, clientOptions) as unknown as QueryObserverOptions,
        queryKey,
        ...queryOptions as unknown as Omit<QueryObserverOptions, "queryKey">
    }) as UseQueryResult<TData, CustomFieldFindMany["error"]> & {
        queryKey: TQueryKey;
    };
    query.queryKey = queryKey as TQueryKey;
    return query;
}
export const customFieldFindManySuspenseQueryKey = (params?: CustomFieldFindMany["queryParams"]) => ["api", "v5", "custom_fields", ...(params ? [params] : [])] as const;
export type CustomFieldFindManySuspenseQueryKey = ReturnType<typeof customFieldFindManySuspenseQueryKey>;
export function customFieldFindManySuspenseQueryOptions(params?: CustomFieldFindMany["queryParams"], options: CustomFieldFindMany["client"]["parameters"] = {}) {
    const queryKey = customFieldFindManySuspenseQueryKey(params);
    return queryOptions({
        queryKey,
        queryFn: async () => {
            const res = await client<CustomFieldFindMany["data"], CustomFieldFindMany["error"]>({
                method: "get",
                url: `/api/v5/custom_fields`,
                params,
                ...options
            });
            return res.data;
        },
    });
}
/**
 * @summary Find many CustomFieldEntity with query
 * @link /api/v5/custom_fields
 */
export function useCustomFieldFindManySuspense<TData = CustomFieldFindMany["response"], TQueryKey extends QueryKey = CustomFieldFindManySuspenseQueryKey>(params?: CustomFieldFindMany["queryParams"], options: {
    query?: Partial<UseSuspenseQueryOptions<CustomFieldFindMany["response"], CustomFieldFindMany["error"], TData, TQueryKey>>;
    client?: CustomFieldFindMany["client"]["parameters"];
} = {}): UseSuspenseQueryResult<TData, CustomFieldFindMany["error"]> & {
    queryKey: TQueryKey;
} {
    const { query: queryOptions, client: clientOptions = {} } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? customFieldFindManySuspenseQueryKey(params);
    const query = useSuspenseQuery({
        ...customFieldFindManySuspenseQueryOptions(params, clientOptions) as unknown as QueryObserverOptions,
        queryKey,
        ...queryOptions as unknown as Omit<QueryObserverOptions, "queryKey">
    }) as UseSuspenseQueryResult<TData, CustomFieldFindMany["error"]> & {
        queryKey: TQueryKey;
    };
    query.queryKey = queryKey as TQueryKey;
    return query;
}